import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Hero } from '../hero';
import { HeroService } from '../hero.service';

@Component({
    selector: 'app-hero-detail',
    templateUrl: './hero-detail.component.html',
    styleUrls: ['./hero-detail.component.css']
})
export class HeroDetailComponent implements OnInit {
    hero: Hero;

    curpath = this.location.path();
    // curpath = this.route.snapshot.url.join('/');

    getHero(): void {
        const id = +this.route.snapshot.paramMap.get('id');
        this.heroService.getHero(id).subscribe(hero => (this.hero = hero));
    }

    save(): void {
        this.heroService.updateHero(this.hero).subscribe(() => this.goBack());
    }

    goBack(): void {
        this.location.back();
    }

    constructor(private route: ActivatedRoute, private heroService: HeroService, private location: Location) {}

    ngOnInit() {
        this.getHero();
    }
}
